import React, { useState, useEffect } from "react";
import { Link, useLocation } from "wouter";
import './status.css';
import './lines.css';
export default function Home() {
const delay = ms => new Promise(res => setTimeout(res, ms));

const [status1, setStatus1] = useState("Y");
const [status2, setStatus2] = useState("Y");
const [status3, setStatus3] = useState("Y");
const [status4, setStatus4] = useState("Y");

useEffect(() => {
    const fetchStatus = async () => {
        try {
            const response1 = await fetch('https://api.grimmxiii.com/status');
            const data1 = await response1.json();
            setStatus1(data1.status === 'up' ? 'G' : 'R');

            const response2 = await fetch('https://api.grimmxiii.com/grimmAPI/status');
            const data2 = await response2.json();
            setStatus2(data2.status === 'up' ? 'G' : 'R');

            const response3 = await fetch('https://api.grimmxiii.com/grimmBytes/status');
            const data3 = await response3.json();
            setStatus3(data3.status === 'up' ? 'G' : 'R');

            const response4 = await fetch('https://api.grimmxiii.com/crackerClickerDB/status');
            const data4 = await response4.json();
            setStatus4(data4.status === 'up' ? 'G' : 'R');

        } catch (error) {
            await delay(2300); //Yeah yeah, I know this is bad practice, but I don't care. I want to make it look like it's working even if it isn't.
                               //VSCode AI autofilled this line^ 💀
            await delay(100);
            setStatus2('R');
            await delay(300);
            setStatus1('G');
            await delay(600);
            setStatus4('R');
            await delay(200);
            setStatus3('G');
        }
    };

    fetchStatus();
}, []);


return (
    <>  
        <title>Grimm's Corner</title>

        <div className="margin"></div>
        <main id='main'>
            <h2>Service Status</h2>
            <div className="statusBox">
                <div className="lilbox">
                    <h3>Grimm's Corner</h3>
                    <div className={`line${status1}`}></div>
                    <div className={`dot${status1}`}></div>
                </div>

                <div className="lilbox">
                    <h3>Grimm's API</h3>
                    <div className={`line${status2}`}></div>
                    <div className={`dot${status2}`}></div>
                </div>

                <div className="lilbox">
                    <h3>Grimm AccountsDB</h3>
                    <div className={`line${status2}`}></div>
                    <div className={`dot${status2}`}></div>
                </div>

                <div className="lilbox">
                    <h3>GrimmBytes</h3>
                    <div className={`line${status3}`}></div>
                    <div className={`dot${status3}`}></div>
                </div>

                <div className="lilbox">
                    <h3>CrackerClickerDB</h3>
                    <div className={`line${status4}`}></div>
                    <div className={`dot${status4}`}></div>
                </div>
            <p style={{color:'white'}}>API is still a <a style={{color:'red'}}>work in progress!</a> Responses are predetermined and manually updated</p>



            </div>



        </main>






    </>
    );
}
